export const aboutProductFiles = ['Composition & compatibility', 'Instructions for use'];
export const relatedProductFiles = ['Wuxal Р Мах', 'Instructions for use'];
